import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom';
interface HeaderProps {
  onToggleSidebar: (isOpen: boolean) => void;
  userName:string;
}
function Header({onToggleSidebar,userName}:HeaderProps) {
  const [sidebarOpen, setSidebarOpen] = useState(true);
   const toggleSidebar = () => {
    const newValue = !sidebarOpen;
    setSidebarOpen(newValue);
    onToggleSidebar(newValue); // send value to parent
  };
  const navigate = useNavigate();
 const handleLogout = () => {
           
    localStorage.removeItem("QuizCredentials");
   
    navigate("/");
 
  };
  return (
    <div>
       <header className="d-flex align-items-center justify-content-between px-4 py-3 bg-primary text-white shadow-sm">
       <div className='position-fixed top-0 end-0 m-2'>
        
        <span className="welcome-text">Welcome, {userName}</span>
           <button
        onClick={handleLogout}
        className="btn btn-primary "
        >
        Logout
      </button>
       </div>
      
        <h4 className="mb-0">CSC Mock Quiz</h4>
        <button
          className="btn btn-outline-light d-md-none"
          //onClick={() => setSidebarOpen(!sidebarOpen)}
          onClick={toggleSidebar}
        >
          ☰
        </button>
      </header>
    </div>
  )
}

export default Header